module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/eba0ee63102b369f93c59a681cd2f5bf.png";